import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetCreditHisotry = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_REPLENISHMENT_HISTORY
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetCreditHistoryAction({
                    list: data.list,
                    page: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetCreditHisotry as SetGetCreditHisotry
}